import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  // Safari fix\n  flex-shrink: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  max-height: ",
        ";\n  transition: max-height 0.3s ease-out;\n  overflow: hidden;\n  border-color: ",
        ";\n  border-style: solid;\n  border-width: 1px 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "@noahswap/localization";
// state/user/hooks
import { useGasPriceManager, useDefaultGasPrice } from "../../../../../../src/state/user/hooks";
// state/types
import { GAS_PRICE_GWEI, GAS_PRICE } from "../../../../../../src/state/types";
import { LinkLabel, MenuEntry } from "./MenuEntry";
import { ArrowDropDownIcon, ArrowDropUpIcon } from "../../Svg";
var Container = styled.div.withConfig({
    componentId: "sc-f667ca3c-0"
})(_templateObject());
var AccordionContent = styled.div.withConfig({
    componentId: "sc-f667ca3c-1"
})(_templateObject1(), function(param) {
    var isOpen = param.isOpen, maxHeight = param.maxHeight;
    return isOpen ? "".concat(maxHeight, "px") : 0;
}, function(param) {
    var isOpen = param.isOpen, isPushed = param.isPushed;
    return isOpen && isPushed ? "rgba(133, 133, 133, 0.1)" : "transparent";
});
var Accordion = function(param) {
    var label = param.label, icon = param.icon, isPushed = param.isPushed, pushNav = param.pushNav, _initialOpenState = param.initialOpenState, initialOpenState = _initialOpenState === void 0 ? true : _initialOpenState, children = param.children, className = param.className, isActive = param.isActive;
    var ref = useState(true), isOpen = ref[0], setIsOpen = ref[1];
    var t = useTranslation().t;
    var handleClick = function() {
        if (isPushed) {
            setIsOpen(function(prevState) {
                return !prevState;
            });
        } else {
            pushNav(true);
            setIsOpen(true);
        }
    };
    // console.log(isOpen, "isOpen");
    var ref1 = useState({
        default: GAS_PRICE.default
    }), gasPriceAll = ref1[0], setGasPriceAll = ref1[1];
    var ref2 = _sliced_to_array(useGasPriceManager(), 2), gasPrice = ref2[0], setGasPrice = ref2[1];
    if (Number(gasPrice) < 900000000000) {
        setGasPrice(GAS_PRICE_GWEI.rpcDefault);
    }
    var defaultGasPrice = useDefaultGasPrice();
    // console.log('defaultGasPrice', defaultGasPrice)
    useEffect(function() {
        if (defaultGasPrice) {
            setGasPriceAll(function(prevGasPrice) {
                return _object_spread_props(_object_spread({}, prevGasPrice), {
                    default: defaultGasPrice
                });
            });
        }
    }, [
        defaultGasPrice
    ]);
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsxs(MenuEntry, {
                onClick: handleClick,
                className: className,
                isActive: isActive,
                children: [
                    icon,
                    /*#__PURE__*/ _jsx(LinkLabel, {
                        isActive: isActive,
                        children: t("".concat(label))
                    }),
                    isOpen ? /*#__PURE__*/ _jsx(ArrowDropUpIcon, {}) : /*#__PURE__*/ _jsx(ArrowDropDownIcon, {})
                ]
            }),
            /*#__PURE__*/ _jsx(AccordionContent, {
                isOpen: isOpen,
                isPushed: isPushed,
                maxHeight: React.Children.count(children) * 70,
                children: children
            })
        ]
    });
};
// export default React.memo(Accordion, (prev, next) => prev.isPushed === next.isPushed);
export default Accordion;
